import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-git4-icon',
  templateUrl: './code-git4.component.html'
})
export class CodeGit4Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
